import { IsOptional, MinLength } from 'class-validator';

import { ListQuery } from '@onArte/shared/models/common';

export class ManufacturerListQuery extends ListQuery {
  @IsOptional()
  @MinLength(0)
  public name?: string;

  constructor(
    limit?: number,
    offset?: number,
    name?: string
  ) {
    super(limit, offset);

    this.name = name;
  }
}
